/**
 * Who the documents come from, and who the privacy policy is about.
 *
 * Constants, not settings. These change roughly never, and a settings screen for them would be a
 * form the owner fills in once and then has to be trusted to have filled in correctly — on a
 * document that carries a GST number. Changing them is a code change and a deploy, which is the
 * right amount of ceremony for the registered details of a company.
 *
 * They live in the shared package rather than on the API because two places print them now: the
 * published documents, and the public privacy policy the worker app serves. A company's
 * registered identity stated two different ways in two places is the kind of drift nobody
 * notices until it matters.
 *
 * Every published document copies these into its snapshot, so a document printed today still
 * carries the address it was issued under even if this file changes later.
 */
export const COMPANY = {
  name: 'S G International - SIVA',
  addressLines: ['Site 400, Pr No 76/1', 'Krishnarajapuram, Kithiganur', 'Bengaluru, Karnataka - 560036'],
  phone: '+91 9743288454',
  gstin: '29AKNPG5420D1ZB',
  /** Signs the service agreement. A payment advice is computer-generated and carries no signature. */
  authorisedSignatory: 'SHIVASHARANAPPA',
} as const;

export type Company = {
  name: string;
  addressLines: string[];
  phone: string;
  gstin: string;
  authorisedSignatory: string;
};

/** A plain copy for a snapshot: the constant is readonly, and a snapshot must be plain JSON. */
export const companySnapshot = (): Company => ({
  name: COMPANY.name,
  addressLines: [...COMPANY.addressLines],
  phone: COMPANY.phone,
  gstin: COMPANY.gstin,
  authorisedSignatory: COMPANY.authorisedSignatory,
});

/**
 * Where a person goes with a complaint about their data, as the Digital Personal Data
 * Protection Act, 2023 requires a notice to say. The office, not a department that does not
 * exist: thirty people work here.
 */
export const GRIEVANCE = {
  email: 'sivalogisticspvt.ltd@gmail.com',
  phone: '+91 97432 88454',
} as const;
